<ion-header>

  <ion-toolbar>

    <ion-title>Yulia</ion-title>

    <ion-buttons slot="end">
      <yu-button
        type="outline"
        color="medium"
        (yuClick)="menuCtrl.close()"
      >
        <yu-icon name="caret-left"></yu-icon>
      </yu-button>
    </ion-buttons>

  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-list class="detail-block no-pb-list" lines="none">

    <ion-item class="no-lines" (click)="newConversation()">
      <yu-icon slot="start" name="plus"></yu-icon>
      <ion-label>{{ 'ASSISTANT.MENU.NEW_CONVERSATION' | translate }}</ion-label>
    </ion-item>

  </ion-list>

  <ion-list class="detail-block" lines="none">

    <ion-list-header>
      <ion-label>{{ 'ASSISTANT.MENU.CHATS' | translate }}</ion-label>

      <yu-icon
        name="magnifying-glass"
        [color]="showSearchbar ? 'success' : 'gradient'"
        (click)="toggleSearchbar()"
      ></yu-icon>
    </ion-list-header>

    @if (showSearchbar) {
      <yu-searchbar
        [setFocus]="true"
        [(value)]="searchValue"
      ></yu-searchbar>
    }

    @for (
        conversation of (conversations || []) | slice: 0: visibleChatsCount | search: searchValue: 'title'; track (conversation.id || $index)) {

      <ion-item-sliding class="yu-item" #itemSld>

        <app-yu-custom-item
          [isButton]="true"
          [description]="conversation.title || ('ASSISTANT.MENU.NO_TITLE' | translate)"
          (click)="selectConversation(conversation)"
        ></app-yu-custom-item>

        <ion-item-options side="end">
          <yu-list-action
            color="info"
            (click)="editConversationTitle(conversation, itemSld)"
          >
            <yu-icon slot="top" name="pencil-simple"></yu-icon>
            {{ 'COMMON.RENAME' | translate }}
          </yu-list-action>

          <yu-list-action
            color="error"
            (click)="confirmDeleteConversation(conversation, itemSld)"
          >
            <yu-icon slot="top" name="trash-simple"></yu-icon>
            {{ 'COMMON.DELETE' | translate }}
          </yu-list-action>
        </ion-item-options>

      </ion-item-sliding>

    } @empty {

      <app-empty-item
        [detailEmpty]="true"
        [title]="'ASSISTANT.MENU.NO_CONVERSATIONS' | translate"
      ></app-empty-item>

    }

    @if (!searchValue && conversations && conversations.length > visibleChatsCount) {

      <ion-item class="no-lines">
        <yu-button
          style="margin: -10px auto"
          color="info"
          type="clear"
          (yuClick)="showMoreChats()"
        >
          {{ 'ASSISTANT.MENU.SHOW_MORE' | translate }}
        </yu-button>
      </ion-item>

    }

  </ion-list>

</ion-content>
